module.exports = __webpack_public_path__ + "img/banner1.bfd9f9a8.jpg";